import { CustomCardColorBar, CustomPanel, PageHeader, PontuacaoCard } from '../../../../components'
import React from 'react'
import { azul, laranja, vinho } from '../../../../assets/js/colors'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'

function EtapaOrdemColeta({ history }) {
  const etapaOrdemColetaInfo = history.location.state.etapa_ordem_coleta_info

  const { pontuacao_total, pontuacao_obtida, tp_name, ordem_coleta_info } = etapaOrdemColetaInfo

  // Helpers

  // Render
  return (
    <>
      <PageHeader>
        Status Operação - &nbsp; <strong>Etapa Ordem de Coleta</strong>
      </PageHeader>
      <div style={{ marginTop: 16 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-9">
              <h2>{tp_name}</h2>
            </div>
            <div className="p-col-3">
              <PontuacaoCard pontuacaoTotal={pontuacao_total} pontuacaoObtida={pontuacao_obtida} />
            </div>
            <div className="p-col-12">
              <OrdemColetaInfo ordemColetaInfo={ordem_coleta_info} />
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

function OrdemColetaInfo({ ordemColetaInfo }) {
  const {
    qte_total_entrega_para_devolucao,
    qte_entregas_devolucao_total,
    qte_entregas_devolucao_parcial,
    qte_devolucao_por_empresa,
  } = ordemColetaInfo

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <PageHeader>Entregas Pendentes Para Devolução</PageHeader>
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={azul}
          value={qte_total_entrega_para_devolucao}
          title={'Qte Entregas Para Devolução'}
          subTitle={'Qte entregas aguardando devolução'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={vinho}
          value={qte_entregas_devolucao_total}
          title={'Qte Devolução Total'}
          subTitle={'Qte entregas - Devolução Total'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={laranja}
          value={qte_entregas_devolucao_parcial}
          title={'Qte Devolução Parcial'}
          subTitle={'Qte entregas - Devolução Parcial'}
        />
      </div>
      <div className="p-col-12">
        <DataTable value={qte_devolucao_por_empresa} emptyMessage={'Nenhum registro encontrado'}>
          <Column field={'empresa'} header={'Empresa'} />
          <Column
            field={'qte_total_entrega_para_devolucao'}
            header={'Qte Total Devolução '}
            style={tableCellCentered(200)}
          />
          <Column
            field={'qte_entregas_devolucao_total'}
            header={'Qte Devolução Total'}
            style={tableCellCentered(200)}
          />
          <Column
            field={'qte_entregas_devolucao_parcial'}
            header={'Qte Devolução Parcial'}
            style={tableCellCentered(200)}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default withRouter(EtapaOrdemColeta)
